var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree-default"},[_c('vue-okr-tree',{ref:"tree",attrs:{"label-height":30,"render-content":_vm.renderContent,"node-key":"id","data":_vm.tree}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }